import { BackTop, Button, Modal, Spin } from 'antd';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { keepState } from './../../../actions/appAction';
import { fromSummary } from './../../../actions/headerAction';
import { onOk, onSort, onSubmit, onTab, update } from './../../../actions/ordersAction';
import Header from './../../../components/header';
import MenuStatus from './../../../components/menu-status';
import TabMenu from './../../../components/tab-menu';
import { orderStatus, FulfillOption as FulfillOptionConst } from './../../../constants';
import { getOrderParams, titleHead } from './../../../services/helper';
import SyncResult from './../components/sync-result';
import Rows from './components/rows';
import './styles.css';

const defaultParams = {
    ChannelOrderID: undefined,
    IsDesc: true,
    OrderBy: "OrderDT",
    OrderDateFrom: undefined,
    OrderDateTo: undefined,
    Page: 1,
    PageSize: 50,
    Status: [orderStatus.AWAITING_FINALIZATION, orderStatus.AWAITING_SHIPMENT],
    SelectedIds: [],
    ChannelID: [],
}

class ListOrder extends Component {
    constructor(props) {
        super(props)

        this.state = {
            style: {}
        }
    }

    componentDidMount() {
        titleHead('List Order')

        // When the user scrolls the page, execute myFunction
        window.onscroll = () => {
            this.handleSticky()
        };

        // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
        let stick = document.getElementsByClassName('ant-tabs-ink-bar')
        if (stick) {
            stick[0].parentNode.removeChild(stick[0])
        }

        if (this.props.isKeepState) {
            this.props.onSubmit({ ...this.props.getOrderParams, isKeepState: true })
            this.props.keepState(false)
        } else if (this.props.FromSummary) {
            this.props.onTab({ tab: this.props.tab, PageSize: this.props.getOrderParams.PageSize })
            this.props.fromSummary({ fromSummary: false })
        } else {
            this.props.onSubmit({ ...defaultParams, PageSize: this.props.getOrderParams.PageSize })
            this.props.update({
                offset: this.props.getOrderParams.PageSize,
                input_filter: {
                    status_list: [orderStatus.AWAITING_FINALIZATION, orderStatus.AWAITING_SHIPMENT],
                    channel: [],
                    channel_order_no: undefined,
                    from: undefined,
                    to: undefined,
                    type_list: [],
                },
                add_filter: false,
            })
        }
    }

    handleSticky = () => {
        // Get the header
        var header = document.getElementById("static-top");
        var divHeader = document.getElementById("header")
        var topHeight = divHeader ? divHeader.clientHeight : 66;

        // Get the offset position of the navbar
        var sticky = header ? header.offsetTop : 0;

        if (header) {
            if (window.pageYOffset > sticky + topHeight) {
                if (this.props.add_filter) {
                    !header.classList.contains('sticky-filter') && header.classList.add("sticky-filter");
                } else {
                    ! header.classList.contains('sticky') && header.classList.add("sticky");
                }

            } else {
                header.classList.contains('sticky') && header.classList.remove("sticky");
                header.classList.contains('sticky-filter') && header.classList.remove("sticky-filter");
            }
        }
    }

    render() {
        return (
            <div id="orders" className='list-order-wraper'>
                <Header history={this.props.history} />
                <Spin spinning={this.props.getting_order} tip="Loading...">
                    <Spin spinning={this.props.sync} tip="Import in progress ...">
                        <div className="wrap-content">
                            <div style={this.state.style} id="static-top">
                                <MenuStatus />
                                <div className='content'>
                                    <TabMenu />
                                </div>
                            </div>
                            <div className="content order-table-area">
                                <SyncResult />
                                <div>
                                    <Modal
                                        visible={this.props.create_shipment_success}
                                        closable={false}
                                        footer={[
                                            <Button
                                                key="ok_modal_create_shipment_success"
                                                type="primary"
                                                onClick={() => {
                                                    this.props.onOk()
                                                    this.props.onSort({ column: this.props.orderBy, params: { ...this.props.getOrderParams, SelectedIds: [] }, reload: true })
                                                }}
                                            >OK</Button>,
                                        ]}
                                    >
                                        <p>Shipment(s) created.</p>
                                    </Modal>

                                    <Modal
                                        visible={this.props.create_shipment_failure}
                                        closable={false}
                                        footer={[
                                            <Button key="ok_modal_create_shipment_failure" type="primary" onClick={() => this.props.onOk()}>OK</Button>,
                                        ]}
                                    >
                                        <p>Create Shipment(s) Failure!</p>
                                    </Modal>
                                    <Modal
                                        visible={this.props.delete_order_success}
                                        closable={false}
                                        footer={[
                                            <Button
                                                key="ok_modal_delete_order_success"
                                                type="primary"
                                                onClick={() => {
                                                    this.props.onOk()
                                                    this.props.onSort({ column: this.props.orderBy, params: { ...this.props.getOrderParams, SelectedIds: [] }, reload: true })
                                                }}
                                            >OK</Button>,
                                        ]}
                                    >
                                        <p>Order successfully deleted!</p>
                                    </Modal>
                                    <table className="table-orders">
                                        <Rows />
                                    </table>
                                </div>
                            </div>
                        </div>
                    </Spin>
                </Spin>
                <BackTop />
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        getting_order: state.ordersReducer.getting_order,
        sync: state.syncReducer.loading,
        add_filter: state.ordersReducer.add_filter,
        orderBy: state.ordersReducer.orderBy,
        getOrderParams: getOrderParams(state),
        create_shipment_success: state.ordersReducer.create_shipment_success,
        create_shipment_failure: state.ordersReducer.create_shipment_failure,
        delete_order_success: state.ordersReducer.delete_order_success,
        isKeepState: state.appReducer.keepState,
        FromSummary: state.headerReducer.fromSummary,
        tab: state.headerReducer.tab,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSort: payload => {
            dispatch(onSort(payload))
        },
        onOk: () => {
            dispatch(onOk())
        },
        onSubmit: payload => {
            dispatch(onSubmit(payload))
        },
        update: (payload) => {
            dispatch(update(payload))
        },
        keepState: payload => {
            dispatch(keepState(payload))
        },
        fromSummary: payload => {
            dispatch(fromSummary(payload))
        },
        onTab: payload => {
            dispatch(onTab(payload))
        },
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ListOrder)



// WEBPACK FOOTER //
// ./src/containers/orders/list/index.js